export default __webpack_public_path__ + "static/media/whole_school_day_tile.596b1fe2.jpg";